export default __webpack_public_path__ + "static/media/Mark-3-HUD-Pop-Up (Phone Call).3badb359.jpg";